'use client';
import React from 'react';
import DynamicComponent from '@repo/ui/src/components/DynamicComponent';
import { trackPage } from '@repo/ui/src/services/analytics';
import { SeoProps } from '@repo/ui/src/types';

import ArticleSeo, { ArticleSeoProps } from './_ArticleSeo';
import RecipeSeo, { RecipeSeoProps } from './_RecipeSeo';
import ProductSeo, { ProductSeoProps } from './_ProductSeo';

interface ArticleJsonLdProps extends ArticleSeoProps {
  type: 'article';
}
interface RecipeJsonLdProps extends RecipeSeoProps {
  type: 'recipe';
}
interface ProductJsonLdProps extends ProductSeoProps {
  type: 'product';
}

export interface Props extends SeoProps {
  contentRows?: Array<string>;
  pageTitle?: string;
  jsonLD?:
    | ArticleJsonLdProps
    | RecipeJsonLdProps
    | ProductJsonLdProps
    | Array<ArticleJsonLdProps | RecipeJsonLdProps | ProductJsonLdProps>;
}

const componentTypes = {
  article: ArticleSeo,
  recipe: RecipeSeo,
  product: ProductSeo,
};

const Seo = ({ contentRows, pageTitle, ogTitle, jsonLD, pageType }: Props) => {
  const title = ogTitle ?? pageTitle;

  React.useEffect(() => {
    trackPage(pageType || 'Page', {
      page_title: title,
      content_rows: contentRows,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageType, title]);

  const jsonLd = Array.isArray(jsonLD) ? jsonLD : [jsonLD].filter(Boolean);

  return (
    <>
      {jsonLd?.map((item, index) => (
        <DynamicComponent key={index} _field="type" _componentTypes={componentTypes} {...item} />
      ))}
    </>
  );
};
export default Seo;
